const selectors = {
  objectForCreatePerformance: (state) =>
    state.createPerformance.objectForCreatePerformance,
  defaultPerformanceInfo: (state) =>
    state.createPerformance.defaultPerformanceInfo,
  submitCreationStatus: (state) => state.createPerformance.submitCreationStatus,
};

export { selectors };
